module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "h2"
  }, [_c('a', {
    attrs: {
      "id": "page_28"
    }
  }, [_vm._v("In which I suffer a bitter disappointment & hope is offered anew")])]), _c('a', {
    attrs: {
      "id": "page_28"
    }
  }, [_c('p', {
    staticClass: "noindent1"
  }, [_c('span', {
    staticClass: "txit"
  }, [_vm._v("January 3, 1778.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Uncle Tascher came from Fort-Royal today with a buggy-load of provisions: coarse cotton fabric for the slaves’ clothing, black crêpe for mourning clothes for us. Then he pulled a letter out of his vest pocket—a letter from Paris! From Aunt Désirée.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Father read the letter. He looked up at his brother. “It’s about Désirée’s godson—the Marquis’s boy.” He snorted. "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("“My.")]), _vm._v("”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Are you not going to read it aloud, Father?” I sat down beside Mother on the sofa. Outside a gentle breeze stirred the palms. Our lovesick bull was bellowing in his pen.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Father began to read. In the letter Aunt Désirée informed Father that the Marquis’s son, Alexandre—“handsome and well educated”—was now seventeen. If he married, he would come into his mother’s inheritance, so Aunt Désirée has suggested he marry one of her nieces—one of "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("us.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("At last! I thought. My prayers had been answered.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("But then Father read out a part about Alexandre preferring Catherine.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "txit"
  }, [_vm._v("Catherine?")]), _vm._v(" “But . . .” I stuttered. It was only two months ago we buried Catherine.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Mother put down her mending. “Let him have her then,” she said. She is like that still—strange somehow.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Father paced the room. “The young chevalier will command an annual income of at least forty thousand livres.”")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_28"
    }
  }), _c('a', {
    attrs: {
      "id": "page_29"
    }
  }, [_vm._v("“Forty thousand?” Grandmother Sannois said, coming into the room. “Did he say forty thousand? Or four?”")])]), _c('a', {
    attrs: {
      "id": "page_29"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("Father stood by the window. “Maybe they would take Manette instead,” he said.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“My thinking exactly, Joseph,” Uncle Tascher said, rubbing his chin.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I didn’t understand. Why not "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("me?")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Manette’s too young,” Mother said.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Four thousand would be an acceptable income,” Grandmother Sannois said.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Manette’s "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("eleven,”")]), _vm._v(" Father said. “By the time—”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Only just,” Mother said.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Eleven and a half. You’re not being reasonable!” Father raised his voice.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Uncle Tascher coughed and poured himself a rum. “Opportunities like this don’t come along every day,” he said.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Why not "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("me?”")]), _vm._v(" I said, standing.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Father looked uneasy. He sighed. “Rose—” He glanced at the letter again. Then he cleared his throat. “The chevalier has expressed a preference for a younger bride. You are too close to him in age—you wouldn’t look up to him the way a wife should.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Mother snorted.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“That’s it exactly,” Father said. He stomped to the door. “God help me!” He slammed the door behind him.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I won’t let you take my baby!” Mother cried.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I ran to my room. I started to throw things into an old haversack. I was going to run, I didn’t care where. Anywhere. Even the empty slave shack down by the shore would be better than this. Even a cave in the mountains, with the runaways.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("That’s when I saw Manette, standing in the door sucking on a stick of sugarcane, her battered wood doll under one arm.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I thought you were playing outside,” I said. I didn’t care about Manette, to tell the truth.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I heard sniffles. “I don’t want to go!”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Oh . . . ,” I said. “You heard all that.” I took her in my arms. “Poor little scarecrow,” calling her the name the slaves had given her.")])]), _c('p', {
    staticClass: "noindent1"
  }, [_c('a', {
    attrs: {
      "id": "page_29"
    }
  }), _c('a', {
    attrs: {
      "id": "page_30"
    }
  }, [_c('span', {
    staticClass: "txit"
  }, [_vm._v("Sunday night, January 4.")])])]), _c('a', {
    attrs: {
      "id": "page_30"
    }
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("I woke to the sound of billiard balls knocking against each other, the sound of men laughing. Uncle Tascher and Father were in the game room. How late was it?")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Why one of "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("your")]), _vm._v(" girls, Joseph?” I heard Uncle demand.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I went to the door, pressed my ear to the crack.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Not that they aren’t lovely,” he went on, “and of baptismal innocence, both of them—but face it, a girl without a dowry? The lad must be desperate. And if he’s such a fine specimen, why must he go halfway around the world for a girl he’s never even seen? And a penniless one at that. If he’s all our sister says he is, it seems to me he would have his pick of any of the pedigreed strumpets in France.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Désirée’s no fool,” I heard my father answer. “How old is the Marquis now anyway? Sixty? Seventy? When he hangs up his fiddle, Désirée will be—” Father made a rude noise.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Then Uncle Robert said something, but I couldn’t make it out.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“If she can make this”—Father’s words became unclear for a moment—“she’ll be legally related. And it wouldn’t do, would it, for a "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("relative")]), _vm._v(" to end her days in a charity hospital.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I heard a chair scrape on the wood floor. “I can see the advantage to Désirée—but why would the "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("son")]), _vm._v(" go along with it?” Uncle Tascher asked.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Does the boy have a choice? Until he’s twenty-one, if his father tells him to jump in the Seine, he’s got to jump in the Seine. And if our sister tells the Marquis to make his son go jump in the Seine, I believe the old bastard would do it. The Devil knows what she does for him in return.” He laughed.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“So you think young Alexandre is being forced into this arrangement?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Not so much forced as bribed. Happiness is an unlimited income, if you ask me. The only way the young chevalier can get his hands on his fortune is to marry. And my guess is that his piss-proud father told him (at our beloved sister’s "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("suggestion,")]), _vm._v(" God bless her): Look, if you want my permission to marry, it must be a Tascher girl.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("There was another burst of laughter and the talk turned to slave prices. I climbed back into bed. I felt a strange tingling in my belly. What did Father mean, that Aunt Désirée had "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("done")]), _vm._v(" something to the Marquis—something that made him do her bidding?")])]), _c('p', {
    staticClass: "noindent1"
  }, [_c('a', {
    attrs: {
      "id": "page_30"
    }
  }), _c('a', {
    attrs: {
      "id": "page_31"
    }
  }, [_c('span', {
    staticClass: "txit"
  }, [_vm._v("January 5.")])])]), _c('a', {
    attrs: {
      "id": "page_31"
    }
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("I told Mimi that Manette might be going to France to be married. “She’s scared,” I said.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“What’s to be scared of?” Mimi asked, mashing the plaintain with violent strokes.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I wasn’t really sure what it was Manette had to be afraid of, but I knew it was something—something to do with dogs climbing over each other, trembling in that pathetic way. “You know, marriage duty.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Is she in flowers yet?”")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_31"
    }
  }, [_vm._v("I shook my head. “What does that have to do with it?” All I know is that the cook isn’t allowed to cure pork when she’s in flowers."), _c('sup', {
    staticClass: "sup"
  })]), _c('a', {
    attrs: {
      "id": "fn-47"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/#fn47"
    }
  }, [_vm._v("I")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Child, don’t they tell you "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("anything!”")]), _vm._v(" But Mimi didn’t tell me anything either.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('span', {
    staticClass: "txit"
  }, [_vm._v("March 17.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Now Manette is ill—she has a fever, just as Catherine had. Mother says it’s her fear of getting married that brought it on.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I crawl in under the covers beside her and try to cheer her. I tell her how grand it will be in France. I tell her about the wonderful dolls they have there, and how our beautiful Aunt Désirée will look after her. I tell her how handsome the chevalier is, how smart and how educated, how noble and how rich. I tell her how envious I am. (Oh, but I am!)")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("But in her fever she only cries. There are nights when I’m so afraid she will die, as Catherine did, in one big moment gone, just a limp body on a rumpled bed, no more or less than a rag doll.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('span', {
    staticClass: "txit"
  }, [_vm._v("June 23, 9:00 "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("P.M.")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Father came back from Sainte-Lucie yesterday. Right away he and Mother got into a quarrel.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_32"
    }
  }, [_vm._v("“But Manette never did want to go!” I heard Mother say. “It was "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("you")]), _vm._v(" put those words in her mouth.”")])]), _c('a', {
    attrs: {
      "id": "page_32"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("She started crying that he "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("couldn’t")]), _vm._v(" take Manette from her, not so soon after losing Catherine. Father yelled, “You crazy créole women and your children!” I felt the walls shake as the door slammed shut.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('span', {
    staticClass: "txit"
  }, [_vm._v("June 24.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Father has relented. He wrote to Aunt Désirée, telling her he wouldn’t be able to bring Manette, she was too sick to go, but how about me? He explained that I wasn’t all "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("that")]), _vm._v(" old, and already well developed.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You know they may not like the idea, Rose,” he told me, sealing the letter with wax. “After all, you’re fifteen.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“When will you find out?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“It will take a few months for my letter to get there and what with the war on—” He stopped to calculate. “Five months?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I moaned. Five months! I want to know "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("now!")])]), _vm._v(" "), _c('hr', {
    staticClass: "hr"
  })]), _c('p', {
    staticClass: "footnote"
  }, [_c('a', {
    attrs: {
      "id": "page_32"
    }
  }), _c('a', {
    attrs: {
      "id": "fn47"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/#fn-47"
    }
  }, [_vm._v("I")]), _vm._v(". "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("The belief that a menstruating woman could spoil a ham was maintained into the nineteenth century. Doctors published papers in medical journals theorizing that when a woman was menstruating her skin became moist, preventing the pork from taking in salt.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-722da8a8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/ch04.vue
// module id = 84
// module chunks = 0